<template>
  <footer class="app-footer">
    <v-container>
      <!-- Brand section above separator -->
      <div class="footer-brand-section">
        <h3 class="footer-brand">Invest Broker</h3>
        <p class="footer-description">{{ $t('footer.description') }}</p>
      </div>

      <!-- Top separator -->
      <div class="footer-separator"></div>

      <!-- 4 Columns -->
      <v-row class="footer-row" no-gutters>
        <!-- Services Group 1 -->
        <v-col cols="6" md="3" class="footer-col">
          <ul class="footer-links">
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.rcai') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.carteVerde') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.property') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.casco') }}</a></li>
          </ul>
        </v-col>

        <!-- Services Group 2 -->
        <v-col cols="6" md="3" class="footer-col">
          <ul class="footer-links">
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.accident') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.travelMedical') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.medical') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.industrial') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.services.liability') }}</a></li>
          </ul>
        </v-col>

        <!-- Navigation -->
        <v-col cols="6" md="3" class="footer-col">
          <ul class="footer-links">
            <li><a href="#" class="footer-link" @click.prevent="navigateTo('#top')">{{ $t('footer.nav.start') }}</a></li>
            <li><a href="#services" class="footer-link" @click.prevent="navigateTo('#services')">{{ $t('footer.nav.services') }}</a></li>
            <li><a href="#quality" class="footer-link" @click.prevent="navigateTo('#quality')">{{ $t('footer.nav.quality') }}</a></li>
            <li><a href="#process" class="footer-link" @click.prevent="navigateTo('#process')">{{ $t('footer.nav.process') }}</a></li>
            <li><a href="#partners" class="footer-link" @click.prevent="navigateTo('#partners')">{{ $t('footer.nav.partners') }}</a></li>
            <li><a href="#answers" class="footer-link" @click.prevent="navigateTo('#answers')">{{ $t('footer.nav.answers') }}</a></li>
            <li><router-link to="/terms" class="footer-link">{{ $t('footer.nav.terms') }}</router-link></li>
          </ul>
        </v-col>

        <!-- Contact Info -->
        <v-col cols="6" md="3" class="footer-col">
          <ul class="footer-contact">
            <li class="contact-item"><a href="tel:+37379463041" class="contact-link">+37379463041</a></li>
            <li class="contact-item"><a href="mailto:office@investbroker.md" class="contact-link">office@investbroker.md</a></li>
            <li class="contact-item">31 August 1989, 31, Chișinău MD-2001</li>
            <li class="contact-item">luni-vineri 09:00 – 18:00</li>
          </ul>
        </v-col>
      </v-row>

      <!-- Bottom separator -->
      <div class="footer-separator"></div>
    </v-container>

    <!-- Bottom Bar -->
    <div class="footer-bottom"></div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    navigateTo(hash) {
      const isHome = this.$route.path === '/'
      if (hash === '#top') {
        if (isHome) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
          this.$router.push('/').then(() => window.scrollTo({ top: 0, behavior: 'smooth' }))
        }
        return
      }
      if (isHome) {
        const el = document.querySelector(hash)
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      } else {
        this.$router.push('/').then(() => {
          setTimeout(() => {
            const el = document.querySelector(hash)
            if (el) el.scrollIntoView({ behavior: 'smooth' })
          }, 100)
        })
      }
    }
  }
}
</script>

<style scoped>
.app-footer {
  background: #ffffff;
  padding: 0;
}

/* Brand section */
.footer-brand-section {
  padding: 30px 0 20px;
}

.footer-brand {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: rgb(31, 177, 193);
  margin-bottom: 4px;
}

.footer-description {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: rgb(46, 46, 46);
  margin: 0;
  max-width: 260px;
}

/* Separator lines */
.footer-separator {
  height: 1px;
  background: rgba(0, 0, 0, 0.05);
  width: 100%;
}

/* Columns row */
.footer-row {
  padding: 30px 0;
}

.footer-col {
  padding: 0 16px 0 0;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 4px;
}

.footer-link {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: rgb(46, 46, 46);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: rgb(28, 165, 190);
}

.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-item {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: rgb(46, 46, 46);
  margin-bottom: 0;
}

.contact-city {
  font-weight: 500;
}

.contact-link {
  color: rgb(46, 46, 46);
  text-decoration: none;
  transition: color 0.2s ease;
}

.contact-link:hover {
  color: rgb(28, 165, 190);
}

.footer-bottom {
  height: 14px;
  background: #1CA5BE;
  width: 100%;
}

/* Responsive */
@media (max-width: 960px) {
  .footer-row {
    padding: 24px 0;
  }

  .footer-col {
    margin-bottom: 24px;
  }
}

@media (max-width: 600px) {
  .footer-brand-section {
    padding: 24px 0 16px;
  }

  .footer-brand {
    font-size: 16px;
  }

  .footer-description {
    font-size: 11px;
  }

  .footer-link,
  .contact-item {
    font-size: 11px;
  }

  .footer-col {
    margin-bottom: 20px;
  }

  .footer-row {
    padding: 20px 0;
  }
}
</style>
